export default "__VITE_ASSET__Mxb4HffL__"